import React from 'react'

function PrivacyPolicy() {
    return (
        <div className=' font-mono '>
            <h1 className=''>Privacy Policy</h1>
            <p>Last updated: February 13, 2024</p>
            <p>
                This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.

            </p>
            <p>
                We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.

            </p>
            <p className='font-bold'>
                Interpretation and Definitions

            </p>
            <p>
                Interpretation
            </p>
            <p>
                The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.

            </p>
            <p className='font-bold'>
                Definitions
            </p>
            <p>
                For the purposes of this Privacy Policy:
            </p>
            <p>
                <span className='font-bold'>
                    Account
                </span>   means a unique account created for you to access our Service or parts of our Service.
            </p>
            <p>
                <span className='font-bold'>
                    Affiliate
                </span>   means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.

            </p>
            <p>
                <span className='font-bold'>
                    Company
                </span>
                (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to  Netstratum Inc, 101 Crawfords Corner Rd., #4-116, 1-158 Holmdel, NJ 07733.

            </p>
            <p>
                <span className='font-bold'>
                    Cookies &nbsp;
                </span>
                are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.

            </p>

            <p>
                <span className='font-bold'>
                    Country &nbsp;
                </span>
                refers to: United States of America
            </p>
            <p>
                <span className='font-bold'>
                    Device &nbsp;
                </span>
                means any device that can access the Service such as a computer, a cell phone or a digital tablet.

            </p>
            <p>
                <span className='font-bold'>
                    Personal Data &nbsp;
                </span>
                is any information that relates to an identified or identifiable individual.
            </p>
            <p>
                <span className='font-bold'>
                    Service &nbsp;
                </span>
                refers to the Website.

            </p>
            <p>
                <span className='font-bold'>
                    Service Provider &nbsp;
                </span>
                means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.
            </p>
            <p>
                <span className='font-bold'>
                    Usage Data &nbsp;
                </span>
                refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).

            </p>
            <p>
                <span className="font-bold">
                    Website &nbsp;
                </span>  refers to Netstratum Technologies, accessible from https://netstratum.co.uk/
                You mean the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.

            </p>

            <p className='text-lg'>
                Collecting and Using Your Personal Data

            </p>
            <p>
                Types of Data Collected

            </p>
            <p>
                Personal Data

            </p>
            <p>
                While using Our Service, We may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to:

            </p>
            <ul>
                <li>
                    Email address

                </li>
                <li>
                    First name and last name

                </li>
                <li>
                    Phone number

                </li>
                <li>
                    Usage Data

                </li>
            </ul>
            <p>
                Usage Data

            </p>
            <p>
                Usage Data is collected automatically when using the service.

            </p>
            <p>
                Usage Data may include information such as your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.

            </p>
            <p>
                When you access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device you use, your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.

            </p>
            <p>
                We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.

            </p>
            <p>
                Tracking Technologies and Cookies

            </p>
            <p>
                We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze our service. The technologies we use may include:
                <ul className='list-disc ml-6'>
                    <li>
                        <b> Cookies or Browser Cookies.</b> A cookie is a small file placed on your device. You can instruct your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted your browser setting so that it will refuse Cookies, our service may use Cookies.
                    </li>
                    <li>
                        <b> Web Beacons.</b> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).

                    </li>
                </ul>
            </p>
            <p>
                Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your personal computer or mobile device when you go offline, while Session Cookies are deleted as soon as you close your web browser.

            </p>
            <p>
                We use both Session and Persistent Cookies for the purposes set out below:

            </p>
            <b>
                Necessary / Essential Cookies
            </b>
            <p>
                Type: Session Cookies
            </p>
            <p>
                Administered by: Us

            </p>
            <p>
                Purpose: These Cookies are essential to provide you with services available through the Website and to enable you to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that you have asked for cannot be provided, and we only use these Cookies to provide you with those services.

            </p>
            <b>
                Cookies Policy / Notice Acceptance Cookies

            </b>
            <p>
                Type: Session Cookies
            </p>
            <p>
                Administered by: Us

            </p>
            <p>
                Purpose: These Cookies identify if users have accepted the use of cookies on the Website.
            </p>
            <b>
                Functionality Cookies

            </b>
            <p>
                Type: Session Cookies
            </p>
            <p>
                Administered by: Us

            </p>
            <p>
                Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.

            </p>
            <p>
                For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.

            </p>
            <b>
                Use of Your Personal Data

            </b>
            <p>
                The Company may use Personal Data for the following purposes:

            </p>
            <p>
                <b>To provide and maintain our Service,</b>  including to monitor the usage of our Service.

            </p>
            <p>
                <b>
                    To manage Your Account:
                </b>
                To manage your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.

            </p>
            <p>
                <b>
                    For the performance of a contract:
                </b>
                The development, compliance and undertaking of the purchase contract for the products, items or services you have purchased or of any other contract with Us through the Service.

            </p>
            <p>
                <b>
                    To contact You:
                </b>
                To contact you by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.

            </p>
            <p>
                <b>
                    To provide You with news,
                </b>
                special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.

            </p>
            <p>
                <b>
                    To manage Your requests:
                </b>
                To attend and manage Your requests to Us.

            </p>
            <p>
                <b>
                    For business transfers:
                </b>
                We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.

            </p>
            <p>
                <b>
                    For other purposes:
                </b>
                We may use your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.

            </p>
            <p>
                We may share Your personal information in the following situations:

            </p>
            <ul className='list-disc ml-6'>
                <li className='list-disc ml-6 ' >
                    <b>
                        With Service Providers:
                    </b>     We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.

                </li>
                <li className='list-disc ml-6'>
                    <b>
                        For business transfers:
                    </b>
                    We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.

                </li>
                <li className='list-disc ml-6'>
                    <b>
                        With Affiliates:
                    </b>
                    We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.

                </li>
                <li className='list-disc ml-6'>
                    <b>
                        With business partners:
                    </b>
                    We may share Your information with Our business partners to offer You certain products, services or promotions.

                </li>
                <li className='list-disc ml-6'>
                    <b>
                        With other users:
                    </b>
                    when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.
                </li>
                <li className='list-disc ml-6'>
                    <b>
                        With Your consent:
                    </b>
                    We may disclose Your personal information for any other purpose with Your consent.

                </li>
            </ul>
            <p>
                <b>
                    Retention of Your Personal Data
                </b>
            </p>
            <p>

                The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
            </p>
            <p>
                The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.

            </p>
            <p>
                <b>
                    Transfer of Your Personal Data
                </b>
            </p>
            <p>

                Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ from those from Your jurisdiction.

            </p>
            <p>
                Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.

            </p>
            <p>
                The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.

            </p>
            <p>
                <b>
                    Delete Your Personal Data

                </b>
            </p>
            <p>
                You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.

            </p>
            <p>
                Our Service may give You the ability to delete certain information about You from within the Service.

            </p>
            <p>
                You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.

            </p>
            <p>
                Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.

            </p>
            <p>
                <b>
                    Disclosure of Your Personal Data

                </b>

            </p>
            <p>
                <b>
                    Business Transactions

                </b>
            </p>
            <p>
                If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.

            </p>
            <p>
                <b>
                    Law enforcement

                </b>
            </p>
            <p>
                Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).

            </p>
            <p>
                <b>
                    Other legal requirements

                </b>
            </p>
            <p>
                The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:

            </p>
            <ul className=''>
                <li className="list-disc ml-6" >
                    Comply with a legal obligation

                </li>
                <li className="list-disc ml-6" >
                    Protect and defend the rights or property of the Company

                </li>
                <li className="list-disc ml-6">
                    Prevent or investigate possible wrongdoing in connection with the Service

                </li>
                <li className="list-disc ml-6">
                    Protect the personal safety of Users of the Service or the public

                </li>
                <li className="list-disc ml-6">
                    Protect against legal liability

                </li>
            </ul>
            <p>
                <b>
                    Security of Your Personal Data

                </b>
            </p>
            <p>
                The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.

            </p>
            <p>
                <b>
                    Children's Privacy

                </b>
            </p>
            <p>
                Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.

            </p>
            <p>
                If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.

            </p>
            <p>
                <b>
                    Links to Other Websites


                </b>
            </p>
            <p>
                Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.

            </p>
            <p>
                We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.

            </p>
            <p>
                <b>
                    Changes to this Privacy Policy

                </b>
            </p>
            <p>
                We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.

            </p>
            <p>
                We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.

            </p>
            <p>
                You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.

            </p>
            <p>
                <b>
                    Contact Us

                </b>
            </p>
            <p>
                If you have any questions about this Privacy Policy, You can contact us:

            </p>
            <p className='ml-6'>
                By email: info@netstratum.com

            </p>
            <p className='ml-6'>
                By visiting this page on our website: https://netstratum.com/

            </p>
            <p className='ml-6'>
                By phone number: +1 (732) 320-9170

            </p>
        </div>
    )
}

export default PrivacyPolicy